import { createAction } from "actions/createAction";
import { EXTRACTED_DUMPS_SET_ITEMS, EXTRACTED_DUMPS_SET_FILTERS } from "const/actionTypes";
import { AnyAction } from "@reduxjs/toolkit";
import { formatLocalDateNoMs } from "utils";


export interface ExtractedDumpsItem {
    time: string;
    ip_src: string;
    ip_dst: string;
    number_from: string;
    number_to: string;
    packets: number;
    finished_at: string;
};



export interface ExtractedDumpsState {
    filters: {
        [key: string]: any;
    };
};

// Initial state
const now = new Date();

const endOfToday = new Date(now);
endOfToday.setHours(23, 59, 59, 999);

const startOfToday = new Date(now);
startOfToday.setDate(startOfToday.getDate());
startOfToday.setHours(0, 0, 0, 0);

const timeFrom = formatLocalDateNoMs(startOfToday);
const timeTo = formatLocalDateNoMs(endOfToday);

const initialState: ExtractedDumpsState = {
    filters: {
        time_from: timeFrom,
        time_to: timeTo,
        number_from: "",
        number_to: "",
        ip_src: "",
        ip_dst: "",
        call_id: ""
    }
};

const handlers = {
    // [EXTRACTED_DUMPS_SET_ITEMS]: (state: ExtractedDumpsState, action: ReturnType<typeof setExtractedDumpsItems>) => ({
    //     ...state,
    //     data: action.payload
    // }),
    [EXTRACTED_DUMPS_SET_FILTERS]: (state: ExtractedDumpsState, action: AnyAction) => ({
        ...state,
        filters: {
            ...state.filters,
            ...action.payload
        }
    }),
    DEFAULT: (state: ExtractedDumpsState) => state
} as const;

const extractedDumpsReducer = (state = initialState, action: AnyAction) => {
    const handle = handlers[action.type as keyof typeof handlers] || handlers.DEFAULT;
    return handle(state, action as any);
};

export default extractedDumpsReducer; 